export default Object.freeze({
  RowIdentifier: 1,
  RowNumber: 2,
});
